import React from 'react';

export interface DeleteLayoutContentProps {
    shareLayoutFeatureToggleEnabled: boolean;
    layoutName: string;
}

export default function DeleteLayoutContent(props: DeleteLayoutContentProps) {
    const { layoutName, shareLayoutFeatureToggleEnabled } = props;

    const sharedNote = shareLayoutFeatureToggleEnabled
        ? 'Please note, shared versions of this layout will still be accessible if it has been shared with others.'
        : '';

    return (
        <div className="DeleteLayoutContent modal-content">
            <span className="title">{`Delete '${layoutName}'`}</span>
            <div className="message important">
                {`Are you sure you want to delete ‘${layoutName}’?`} This action
                cannot be undone. {sharedNote}
            </div>
        </div>
    );
}
